module.exports = "../../../../platform/assets/pageMainIcon/youth_.svg";